
const getSiteValuefromLocation = () => {
  // used to ensure correct recaptcha token is used if site hasnt loaded from tealium yet.
  switch (window.location.hostname) {
  case 'www.news.com.au': return 'newscomau';
  case 'www.codesports.com.au': return 'cs';
  default: return '';
  }
};


// Get Context data for web environment from existing page js objects.
const getWebEnvData = () => {
  const ud = window.utag_data || {};
  console.log('handleParams queryParamStr ud', ud.pc_memtype, window.utag_data );
  const capiMeta = document.querySelector('meta[name="articleid"]');
  const capiId = (capiMeta && capiMeta.getAttribute('content')) || ud.net_article_id;
  const capiUrl = window.location.href;
  const premiumStatus = ud.pc_conttyperule;
  const newsKey = ud.newskey; // window.newskey.nk, window.utag_data.newskey, ncg_data.device_id
  const userId = ud.pc_pcsid || window.newscorpau?.auth?.['http://login.newscorpaustralia.com.au/profile']?.think_id; // window.utag_data.pc_pcsid, ncg_data.user_id
  const userAccessLevel = ud.pc_memtype; // window.utag_data.pc_memtype, ncg_data.user_memtype
  const site = ud.site_short || getSiteValuefromLocation();
  const section = ud.net_sec1; // window.utag_data.site_short

  if (window.location.search.match('debugEditorialTools')) {
    console.log('utag', window.utag_data, JSON.stringify(ud));
    console.log('site_short', ud.site_short, site);
    console.log('newskey', window.newskey.nk, window.utag_data.newskey, window.ncg_data);
    console.log('userId', window.utag_data.pc_pcsid, window.ncg_data, window.newscorpau?.auth?.['http://login.newscorpaustralia.com.au/profile']?.think_id);
    console.log('userAccessLevel', window.utag_data.pc_memtype, window.ncg_data);
  }

  return {
    site,
    section,
    capiId,
    capiUrl,
    premiumStatus,
    userId,
    userAccessLevel,
    newsKey,
  };
};

const mapAmpBrand = (brand) => {
  const brandMap = {
    'dailytelegraph': 'dt',
    'adelaidenow': 'adv',
    'couriermail': 'cm',
    'heraldsun': 'hs',
    'cairnspost': 'cp',
    'townsvillebulletin': 'tb',
    'ntnews': 'ntn',
    'goldcoastbulletin': 'gcb',
    'geelongadvertiser': 'ga',
    'mercury': 'merc',
    'weeklytimesnow': 'wtn',
    'theaustralian': 'taus',
    'thechronicle': 'twc',
    'newscomau': 'nca',
  };

  return brandMap[brand] || brand;
};

const matchValues = (str, regex, matchIndex = 0) => {
  const match = (str || '').match(regex);
  if (match && match[matchIndex]) {
    return match[matchIndex];
  }
};

export const getAmpEnvData = (meta) => {
  console.log(meta);

  const {
    net_site,
    net_sec1,
    net_article_id,
    net_article_headline,
    userId: _userId,
    userAccessLevel: _userAccessLevel,
    newsKey,
    capiId,
    capiUrl,
    section,
    brand,
    title,
    ...utagData
  } = meta || {};

  const site = net_site || mapAmpBrand(brand);
  const userId = matchValues(_userId, /^[0-9]{2,10}$/) || 'none';
  const userAccessLevel = matchValues(_userAccessLevel, /^subscriber|registered|anonymous$/) || 'anonymous';

  // set any other values passed through directly to utag_data
  window.utag_data = utagData;

  console.log('getAmpEnvData val', site, userId, userAccessLevel, window.utag_data);

  return {
    site,
    section: section || net_sec1,
    capiId: capiId || net_article_id,
    capiUrl: decodeURIComponent(capiUrl),
    // premiumStatus,
    userId,
    userAccessLevel,
    newsKey,
    title: title || net_article_headline,
  };
};

// Get the correct environment context data for current channel
export default function getDataForChannel(props) {
  const hasAppDiv = document.getElementById('screenkit--embed-container');
  console.log('hasAppDiv', hasAppDiv);

  if (window.DNA_APP_ENV || hasAppDiv) {
    const data = window.DNA_APP_ENV || {};
    document.title = `Editorial Tools: ${ props.type } - ${ props.id }`;
    const body = document.querySelector('body');
    if (body) {
      body.classList.add('et_app_webview');
      if (data.site) body.classList.add(data.site);
    }

    return {
      ...data,
      ...props,
      channel: 'app',
      isApp: true,
      loadTealium: data.site ? true : false,
      loadRampart: true
    };
  } else if (window.DNA_AMP_ENV || props.isAmp) {
    return {
      ...(window.DNA_AMP_ENV || {}),
      ...props,
      channel: 'amp',
      isAmp: true,
      loadTealium: true
    };
  } else {
    return {
      ...getWebEnvData(),
      ...props,
      channel: 'web',
      isWeb: true,
    };
  }
}

const handleQueryParam = (queryParamStr) => {
  const queryParamStrFind = `mock_${ queryParamStr.channelObj }_${ queryParamStr.userObj }`;
  console.log('handleQueryParam mastheadObj', queryParamStrFind, queryParamStr);
  switch (queryParamStrFind) {
  case 'mock_web_anonymous':
    return {
      site_short: queryParamStr.mastheadObj, //'cm'
      net_sec1: 'sport',
      title: 'Uat / Local dev hybrid test for android studio app',
      net_article_id: '7939ce2c8cee539bd3a0c47ba6cebfb7',
      env: 'uat',
      pc_memtype: 'anonymous',
      pc_pcsid: 'none',
      userAccessLevel: null,
      isPreview: false,
      newskey: 'bcceb000ac18d423da387864d859e981'
    };
  case 'mock_web_registered':
    return {
      site_short: queryParamStr.mastheadObj,
      net_sec1: 'sport',
      title: 'Uat / Local dev hybrid test for android studio app',
      net_article_id: '7939ce2c8cee539bd3a0c47ba6cebfb7',
      env: 'uat',
      userAccessLevel: 'registered',
      pc_memtype: 'registered',
      pc_pcsid: '7047592',
      newskey: 'bcceb000ac18d423da387864d859e981'
    };
  case 'mock_web_subscriber':
    return {
      site_short: queryParamStr.mastheadObj,
      net_sec1: 'sport',
      title: 'Uat / Local dev hybrid test for android studio app',
      net_article_id: '7939ce2c8cee539bd3a0c47ba6cebfb7',
      env: 'uat',
      userAccessLevel: 'subscriber',
      pc_memtype: 'subscriber',
      pc_pcsid: '48953181',
      newskey: 'bcceb000ac18d423da387864d859e981'
    };

  case 'mock_app_subscriber':
    return {
      accessType: 'NON_PREMIUM',
      byline: '',
      capiId: 'd886ff5b5bf7c88a5f0ceb9fcc375d12',
      commentsAllowed: false,
      deviceId: 'asdf1234_deviceid_from_app',
      dateLive: '2019-08-14 23:26:06 +0000',
      dateUpdated: '2019-08-14 23:14:13 +0000',
      env: 'uat',
      hasVideos: false,
      isBlog: false,
      originalSource: 'The Daily Telegraph',
      platform: 'ios',
      route: 'sport/nrl',
      section: 'sport',
      site: queryParamStr.mastheadObj,
      title: 'Crazy man tests embeds on Masthead apps',
      userAccessLevel: 'registered',
      userId: '37639277',
      // newsKey: "bcceb000ac18d423da387864d859e981"
    };
  case 'mock_app_anonymous':
    return {
      accessType: 'NON_PREMIUM',
      byline: '',
      capiId: 'd886ff5b5bf7c88a5f0ceb9fcc375d12',
      commentsAllowed: false,
      deviceId: 'asdf1234_deviceid_from_app',
      dateLive: '2019-08-14 23:26:06 +0000',
      dateUpdated: '2019-08-14 23:14:13 +0000',
      env: 'uat',
      hasVideos: false,
      isBlog: false,
      originalSource: 'The Daily Telegraph',
      platform: 'ios',
      route: 'sport/nrl',
      section: 'sport',
      site: queryParamStr.mastheadObj,
      title: 'Crazy man tests embeds on Masthead apps',
      userAccessLevel: null,
      userId: null,
      // newsKey: "bcceb000ac18d423da387864d859e981"
    };

  case 'mock_amp_anonymous':
    return {
      site_short: queryParamStr.mastheadObj, //'cm'
      net_sec1: 'lifestyle',
      title: 'Uat / Local dev hybrid test for android studio app',
      net_article_id: '7939ce2c8cee539bd3a0c47ba6cebfb7',
      env: 'uat',
      userAccessLevel: 'anonymous',
      userId: 'none',
      capiUrl: 'https://www.goldcoastbulletin.com.au/lifestyle/best-of-gold-coast/finalists-announced-best-vet-on-the-gold-coast/news-story/b21b5515fccd899afe1d8a2452b9b22c',
    };
  case 'mock_amp_registered':
    return {
      site_short: queryParamStr.mastheadObj,
      net_sec1: 'lifestyle',
      net_article_id: 'b21b5515fccd899afe1d8a2452b9b22c',
      env: 'uat',
      userAccessLevel: 'registered',
      // userId: '37639277',
      userId: '7047592',
      capiUrl: 'https://www.goldcoastbulletin.com.au/lifestyle/best-of-gold-coast/finalists-announced-best-vet-on-the-gold-coast/news-story/b21b5515fccd899afe1d8a2452b9b22c',
    };
  case 'mock_amp_subscriber':
    return {
      site_short: queryParamStr.mastheadObj,
      net_sec1: 'lifestyle',
      net_article_id: 'b21b5515fccd899afe1d8a2452b9b22c',
      env: 'uat',
      userAccessLevel: 'subscriber',
      userId: '37639277',
      capiUrl: 'https://www.goldcoastbulletin.com.au/lifestyle/best-of-gold-coast/finalists-announced-best-vet-on-the-gold-coast/news-story/b21b5515fccd899afe1d8a2452b9b22c',
    };
  default:
    return {};
  }

// window.location.reload(false)
};
export function getDataForChannelPreview(props) {


  const ud = handleQueryParam(props.previewParam) || {};


  console.log(props.previewParam, ud);

  const body = document.querySelector('body');

  if (props.previewParam.channelObj === 'app' && ( props.previewParam.userObj === 'anonymous' || props.previewParam.userObj === 'subscriber' || props.previewParam.userObj === 'registered') ) {
    console.log('handleParams queryParamStr getDataForChannelPreview', props.previewParam, ud);
    const data = ud || {};
    document.title = `Editorial Tools: ${ props.type } - ${ props.id }`;

    if (body) {
      body.classList.add('et_app_webview');
      if (data.site) body.classList.add(data.site);
    }
    return {
      ...data,
      ...props,
      channel: 'app',
      isApp: true,
      loadTealium: true,
      loadRampart: true
    };

  } else if (props.previewParam.channelObj === 'amp') {
    const data = ud || {};
    return {
      ...data,
      ...props,
      channel: 'amp',
      isAmp: true,
      loadTealium: true,
    };
  } else {
    if (body) {
      body.classList.remove('et_app_webview');
      if (ud.site_short) body.classList.remove(ud.site_short);
    }
    const capiMeta = document.querySelector('meta[name="articleid"]');
    const capiId = (capiMeta && capiMeta.getAttribute('content')) || ud.net_article_id;
    const capiUrl = window.location.href;
    const premiumStatus = ud.pc_conttyperule;
    const newsKey = ud.newskey; // window.newskey.nk, window.utag_data.newskey, ncg_data.device_id
    const userId = ud.pc_pcsid; // window.utag_data.pc_pcsid, ncg_data.user_id
    const userAccessLevel = ud.pc_memtype; // window.utag_data.pc_memtype, ncg_data.user_memtype
    const site = ud.site_short;
    const section = ud.net_sec1; // window.utag_data.site_short
    return {
      ...props,
      site,
      section,
      capiId,
      capiUrl,
      premiumStatus,
      userId,
      userAccessLevel,
      newsKey,
      channel: 'web',
      isWeb: true,
      loadTealium: true,
    };
  }


}
